<ng-container
  *ngIf="{
    isSessionConnected: isSessionConnected$ | async
  } as data"
>
  <div class="workspace-switch_buttons">
    <button
      type="button"
      class="interaction"
      title="{{ 'agent:panel.visio.interaction' | translate }}"
      (click)="switchWorkspace('interaction')"
      [attr.aria-pressed]="interactionWorkspaceEnabled"
      [ngClass]="{ selected: interactionWorkspaceEnabled }"
    >
      <span class="nodisplay">{{ 'agent:panel.visio.interaction' | translate }}</span>
    </button>
    <button
      type="button"
      class="qualification"
      title="{{ 'agent:panel.visio.qualification' | translate }}"
      (click)="switchWorkspace('qualification')"
      [attr.aria-pressed]="!interactionWorkspaceEnabled"
      [ngClass]="{ selected: !interactionWorkspaceEnabled }"
      disabled
    >
      <span class="nodisplay">{{ 'agent:panel.visio.qualification' | translate }}</span>
    </button>
  </div>
  <div class="workspace-container">
    <div class="workspace-interaction" [hidden]="!interactionWorkspaceEnabled">
      <ng-container *ngIf="data.isSessionConnected">
        <div class="main-stream">
          <cng-visio-main-stream [stream]="mainStream"></cng-visio-main-stream>
        </div>
        <div
          class="secondary-streams"
          *ngIf="data.isSessionConnected"
          [hidden]="(subscriberStreamList$ | async)?.length == 0 && !(publisherScreenStream$ | async)"
        >
          <div class="others-streams" *ngIf="(subscriberStreamList$ | async).length >= 1">
            <ng-container *ngFor="let stream of subscriberStreamList$ | async">
              <cng-visio-subscriber
                [hidden]="!!mainStream && mainStream?.streamId === stream?.streamId"
                [stream]="stream"
                (select)="select(stream)"
              ></cng-visio-subscriber>
            </ng-container>
          </div>
          <cng-visio-publisher
            *ngIf="data.isSessionConnected"
            [hidden]="!!mainStream && mainStream?.streamId === (publisherCameraStream$ | async)?.streamId"
          >
          </cng-visio-publisher>
        </div>
      </ng-container>
      <ng-container *ngIf="!data.isSessionConnected">
        <div class="connection-in_progress">
          <p>{{ 'agent:panel.visio.connectionInProgress' | translate }}</p>
        </div>
      </ng-container>
    </div>
    <div class="workspace-qualification" [hidden]="interactionWorkspaceEnabled">
      <div class="qualification_form-header">
        <h3>{{ 'agent:panel.visio.qualification' | translate }}</h3>
      </div>
      <div class="qualification_form-content">
        <p>{{ 'agent:panel.visio.qualification' | translate }}</p>
      </div>
    </div>
  </div>
</ng-container>
